import { useParams } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { GoBackButton } from "../../../../../components/GoBackButton";

import OfferingPositionAddForm from "./offering-add-position-form";

const OfferingPositionAdd = () => {
  const { id } = useParams();

  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <OfferingPositionEditContainer>
        <OfferingPositionAddForm subcontractorOfferId={id} />
      </OfferingPositionEditContainer>
    </>
  );
};

export default OfferingPositionAdd;

const OfferingPositionEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
